import $ from "jquery";

window.$ = window.$ || $;
window.jQuery = window.jQuery || $;

export default window.jQuery;
